import React from 'react';

// Tokens that can be used in email templates. These mirror the constants defined
// in db/email_body.go (kept in the same order) and are substituted when a claim
// email is generated. GAP letters are built in gap/email_body.go and LWT letters
// in lwt/lwt_email_body.go; a token left in a template whose type does not support
// it is sent to the customer verbatim. `type` flags the exceptions:
//   'gap' -> substituted only in GAP claim letters
//   'lwt' -> substituted only in LWT claim letters
//   undefined -> substituted in both
const TOKENS = [
  { token: '{{DateToday}}', explanation: "Today's date (e.g. January 2, 2026)." },
  { token: '{{CustomerNameFull}}', explanation: "The customer's full name (\"First Last\"). For a business customer, the business name is appended as \"First Last/BusinessName\"." },
  { token: '{{CustomerNameFirst}}', explanation: "The customer's first name." },
  { token: '{{CustomerNameLast}}', explanation: "The customer's last name." },
  { token: '{{CustomerAddress}}', explanation: "The customer's street address." },
  { token: '{{CustomerCity}}', explanation: "The customer's city." },
  { token: '{{CustomerState}}', explanation: "The customer's state code (e.g. UT)." },
  { token: '{{CustomerZip}}', explanation: "The customer's ZIP / postal code." },
  { token: '{{CustomerAddressFull}}', explanation: "The customer's full address: street, city, state and ZIP." },
  { token: '{{GapContractNumber}}', type: 'gap', explanation: 'The GAP contract number from the claim.' },
  { token: '{{GapMissing}}', type: 'gap', explanation: 'The list of outstanding / missing documents required for the claim.' },
  { token: '{{GapCalculateCaseReserve}}', type: 'gap', explanation: 'The calculated case reserve breakdown. Used in the No GAP letter.' },
  { token: '{{DealershipName}}', explanation: 'The issuing dealership name.' },
  { token: '{{PoliceReport}}', type: 'gap', explanation: 'The police report notes recorded on the claim.' },
  { token: '{{VINNumber}}', type: 'gap', explanation: "The vehicle's VIN." },
  { token: '{{DOLMileage}}', type: 'gap', explanation: 'The vehicle mileage from the valuation report (date-of-loss mileage).' },
  { token: '{{DOL}}', type: 'gap', explanation: 'The date of loss.' },
  { token: '{{DealNumber}}', explanation: 'The deal number from the contract.' },
  { token: '{{VehicleMake}}', explanation: "The vehicle's make." },
  { token: '{{VehicleModel}}', explanation: "The vehicle's model." },
  { token: '{{VehicleYear}}', explanation: "The vehicle's year." },
  { token: '{{ContractEffectiveDate}}', explanation: "The contract's effective date." },
  { token: '{{ContractNumber}}', type: 'lwt', explanation: 'The contract number.' },
];

export default class TemplateTokenHelpModal extends React.Component {
  renderGap() {
    return <span className="badge badge-info">GAP</span>;
  }

  renderLwt() {
    return <span className="badge badge-warning">LWT</span>;
  }

  renderTypeBadge(type) {
    if (type === 'gap') {
      return this.renderGap();
    }
    if (type === 'lwt') {
      return this.renderLwt();
    }
    return null;
  }

  render() {
    return (
      <div>
        <p>The following is a list of fields and the value each one is replaced with when a GAP or LWT claim email is generated.  Type a field exactly as shown, including the <code style={ { color: 'inherit' } }>{'{{ }}'}</code> braces.  Any text that does not match a field listed below is sent to the customer unchanged.</p>
        <p>{ this.renderGap() } - indicates that the field is substituted only in GAP claim letters.</p>
        <p>{ this.renderLwt() } - indicates that the field is substituted only in LWT claim letters.</p>
        <p>Fields without a badge are substituted in both GAP and LWT templates.</p>
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Field Name</th>
              <th>Explanation</th>
            </tr>
          </thead>
          <tbody style={ { fontSize: '85%' } }>
            { TOKENS.map((t) => (
              <tr key={ t.token }>
                <td><code style={ { color: 'inherit' } }>{ t.token }</code> { this.renderTypeBadge(t.type) }</td>
                <td>{ t.explanation }</td>
              </tr>
            )) }
          </tbody>
        </table>
      </div>
    );
  }
}
